/**
 * Lý do giảm
 */
export default {
  /// Thanh lý
  Liquidation: 0,

  /// Điều chuyển
  Transfer: 1,

  /// Bán đấu giá
  Auction: 2,

  /// Bán chỉ định
  DesignatedSale: 3,

  /// Chuyển nhượng
  Assign: 4,

  /// Mất
  Missing: 5,

  /// Tiêu hủy
  Destroy: 6,

  /// Hình thức khác
  AnotherForm: 7,
};
